import i18next from "i18next";
import { filesContentOptions } from "./FileOptions";
import {
  HistoryFileActionDescriptionRecord,
  HistoryFileIconRecord,
} from "Data/interfaces/History/IHistoryFileRecord";
import { HistoryFileActionEnum } from "Data/interfaces/History/IHistoryFileApi";

const contentFileIcon: HistoryFileIconRecord = {
  [HistoryFileActionEnum.StatusChanged]: { icon: 'trocarStatus' },
  [HistoryFileActionEnum.FileDownloaded]: { icon: 'download' },
  [HistoryFileActionEnum.FileDeleted]: { icon: 'excluir' },
  [HistoryFileActionEnum.FileMoved]: { icon: 'mover' },
  [HistoryFileActionEnum.FolderCreated]: { icon: 'adicionarPasta', size: 16 },
  [HistoryFileActionEnum.FolderDeleted]: { icon: 'excluir' },
  [HistoryFileActionEnum.FileRenamed]: { icon: 'input', size: 16 },
  [HistoryFileActionEnum.DescriptionUpdated]: { icon: 'collapse', size: 8 },
  [HistoryFileActionEnum.FileCreated]: { icon: 'upload' },
  [HistoryFileActionEnum.FileVersionAdded]: { icon: 'upload' },
  [HistoryFileActionEnum.FileRendered]: { icon: 'editar', size: 8 },
  // [HistoryFileActionEnum.obsolet]: { icon: 'obsoleteArchive' },
  // [HistoryFileActionEnum.edit]: { icon: 'editar' },
}

const actionFileDescription: HistoryFileActionDescriptionRecord = {
  get [HistoryFileActionEnum.StatusChanged]() { return i18next.t('listagemArquivos:history.updatedFile'); },
  get [HistoryFileActionEnum.FileDownloaded]() { return i18next.t('listagemArquivos:history.downloadedFile'); },
  get [HistoryFileActionEnum.FileDeleted]() { return i18next.t('listagemArquivos:history.deletedFile'); },
  get [HistoryFileActionEnum.FileMoved]() { return i18next.t('listagemArquivos:history.movedFile'); },
  get [HistoryFileActionEnum.FolderCreated]() { return i18next.t('listagemArquivos:history.createdFolder'); },
  get [HistoryFileActionEnum.FolderDeleted]() { return i18next.t('listagemArquivos:history.deletedFolder'); },
  get [HistoryFileActionEnum.FileRenamed]() { return i18next.t('listagemArquivos:history.renamedFile'); },
  get [HistoryFileActionEnum.DescriptionUpdated]() { return i18next.t('listagemArquivos:history.updatedDescription'); },
  get [HistoryFileActionEnum.FileCreated]() { return i18next.t('listagemArquivos:history.sentFile'); },
  get [HistoryFileActionEnum.FileVersionAdded]() { return i18next.t('listagemArquivos:history.sentRevision'); },
  get [HistoryFileActionEnum.FileRendered]() { return i18next.t('listagemArquivos:history.fileRendered'); },
} as HistoryFileActionDescriptionRecord;

export { filesContentOptions, contentFileIcon, actionFileDescription };
